import { Component, OnInit, ViewContainerRef } from '@angular/core';
import {Router} from "@angular/router";
import { LoginService } from '../nservices/login/login.service';
import { SignUpModel } from '../nmodels/auth/signup.model';
import { CredentialsService } from '../nservices/login/credentials.service';
import { CredentialsModel } from '../nmodels/auth/credentials.model';
import { AnonymousModel } from '../nmodels/auth/anonymous.model';
import { ToastsManager } from 'ng2-toastr';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  login_email:string = "";
  login_password:string = "";
  anonymus:boolean = false;
  signup:SignUpModel;
  constructor(private _loginS:LoginService,private _router:Router,private _credentialsS:CredentialsService,
    public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr); 
      if(this._credentialsS.getCredentials()){
        this._router.navigate(['home']);
      }
      else{
        this.signup = new SignUpModel();
      }
      
  }

  ngOnInit() {
  }

  userSignUp(){
    this._loginS.userSignUp(this.signup)
        .subscribe(resp =>{
            this._loginS.userLogin(this.signup.email,this.signup.password)
                .subscribe(resp =>{
                  let credentials:CredentialsModel = resp;
                  this.saveCredentials(credentials);
                  this._router.navigate(['home'],{ queryParams: { fromSignup: "1" } });
                });
        })
  }


  userLogin(){
    if(this.anonymus){
      console.log("usuario anonimo");
      let anonymusmodel:AnonymousModel = new AnonymousModel();
      anonymusmodel.anonymous = "Usuario Anonimo";
      anonymusmodel.ishidden = true;
      this._credentialsS.setCredentialsAnonynous(anonymusmodel);
      this._router.navigate(['home']);
    }else{
      this._loginS.userLogin(this.login_email,this.login_password)
                .subscribe(resp =>{
                  let credentials:CredentialsModel = resp;
                  this.saveCredentials(credentials);
                  this._router.navigate(['home']);
                });
    }
  }

  saveCredentials(credentials:CredentialsModel){
    console.log(credentials);
    this._credentialsS.setCredentials(credentials);
  }





}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/login/login.component.ts